import { ENDPOINTS } from "../config";

/**
 * Fetch the active SEO field configured for a given page path.
 * Returns the SEO record ({ pageUrl, metaTitle, metaDescription, metaKeywords,
 * robotsTag, publisher, lang }) or null when no active entry exists for the path.
 *
 * @param {string} url - The page path, e.g. "/products"
 * @returns {Promise<Object|null>}
 */
export const getSeoByUrl = async (url) => {
    try {
        const response = await fetch(ENDPOINTS.SEO.BY_URL(url));
        const data = await response.json();
        if (data?.isOk) {
            return data.data || null;
        }
        return null;
    } catch (error) {
        console.error("Error fetching SEO field:", error);
        return null;
    }
};

export default { getSeoByUrl };
